"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkRequired;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * Check object for the specified keys
 * @param {Array<string>} keys
 * @param {Object} object
 * @returns {undefined}
 * @throws Error
 */
function checkRequired(keys, object) {
  keys.forEach(function (key) {
    if (!object[key]) {
      throw new Error("missing required property ".concat(key, " from ").concat(object));
    }
  });
}
//# sourceMappingURL=check-required.js.map
